/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import parse from 'html-react-parser';
import {styles} from "./ResultPage.styles"
import ApplicationElement from "../components/ApplicationElement";
import Scoring from "../../AutoPanel/components/Application/components/Scoring";
import PageHeader from "./partials/PageHeader";

import { Typography, Fab, Paper, Grid } from '@material-ui/core';

class ResultPage extends PureComponent {

    state = {};

    componentDidMount() {
    }

    render() {
        const {classes, resultPage} = this.props;
        const elementContainer = resultPage.elementContainer
        return (
            <div key={'questionApp'}>
                <PageHeader/>
                <Grid container className={classes.container}>
                    <Paper className={classes.paper} elevation={1}>
                        <div>
                            <div className={classes.root}>
                                {
                                    elementContainer && elementContainer.map((elementItem, index) => {
                                        return (<div className={classes.elementItem}>
                                            <Typography component="h1" variant={elementItem.titleSize} align="center"
                                                        className={classes.title}>{elementItem.title}</Typography>
                                            {elementItem.description &&
                                            <Typography variant="body1" align="center" color="textSecondary"
                                                        className={classes.description}>{parse(elementItem.description)}</Typography>}
                                            {elementItem.elements && elementItem.elements.map((element, key) =>
                                                <ApplicationElement
                                                    element={element}/>)
                                            }

                                            {elementItem.button &&
                                            <div className={classes.buttonWrapper}><a href={elementItem.button.url}
                                                                                      target="_blank">
                                                <Fab variant="extended"
                                                     color="primary"
                                                     size="medium"
                                                     disabled={!elementItem.button.active}
                                                     className={classes.button + ' forwardButton'}>
                                                    {elementItem.button.label}
                                                    {elementItem.button.icon &&
                                                    <FontAwesomeIcon className={classes.rightIcon} size="lg"
                                                                     icon={['far', elementItem.button.icon]}/>}
                                                </Fab>
                                            </a></div>}
                                            {elementItem.scoring &&
                                            <Scoring first={elementItem.scoring.first}
                                                     second={elementItem.scoring.second}
                                                     third={elementItem.scoring.third}/>}

                                        </div>)
                                    })
                                }
                            </div>
                        </div>
                    </Paper>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(ResultPage);
